import axios from "axios";

export const downloadReport = async( api ) => {
    try{
        // console.log("JSON-DATA", jsonData);
        const sendRequest = await axios.get(`${process.env.REACT_APP_API_URL}${api}`, {
            headers: {
                "Content-Type" : "application/json"
            },
            responseType: 'blob'
        });

        console.log("response of file", sendRequest)
        if(sendRequest?.data?.type === "application/json"){
            alert("No Data found")
        }else{
            const response = await sendRequest.data;
            alert(response?.data?.message || "Download excel successfully.")
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${(new Date()).toDateString()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }
        
    }catch(error){
        console.log(error);
    }
}